// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { getPrice } from '../../common/utils/priceUtil';
export const getCabinBaggagePrice = (name, form) => state => getPrice(name, form)(state);
//# sourceMappingURL=price.js.map